import { axios } from '@/services/axios';

const createPartner = async (formData) => {
    const response = await axios.post('/partner', formData);
    return response;
};

export default createPartner;
